<main id="content" #content class="home-container">
  <section class="border-bottom-light" aria-describedby="ariaMainHeaderId">
    <div class="grid-container">
      <div class="grid-x grid-margin-x">
        <div class="cell medium-6">
          <h1 id="ariaMainHeaderId">
            {{ homeCmsData?.data?.attributes?.homeFirstSection?.header }}
          </h1>
          <p class="lead">
            {{ homeCmsData?.data?.attributes?.homeFirstSection?.description }}
          </p>
          <div aria-hidden="true" class="banner-image hide-for-medium banner-image--pixel-depth_1x" [ngStyle]="{
              'background-image':
                'url(' +
                homeCmsData?.data?.attributes?.homeFirstSection?.image1x?.data
                  ?.attributes?.url +
                ')'
            }"></div>
          <div aria-hidden="true" class="banner-image hide-for-medium banner-image--pixel-depth_2x" [ngStyle]="{
              'background-image':
                'url(' +
                homeCmsData?.data?.attributes?.homeFirstSection?.image2x?.data
                  ?.attributes?.url +
                ')'
            }"></div>
          <ul class="no-bullet link-button-list">
            <li>
              <a *ngIf="!this.userSignedIn"
                [routerLink]="[registrationLink]"
                class="button primary medium-down-expanded large no-underline"
                >{{
                  homeCmsData?.data?.attributes?.homeFirstSection
                    ?.registerButtonText
                }}</a
              > <a *ngIf="this.userSignedIn"
              [routerLink]="[myLearningLink]"
              class="button primary medium-down-expanded large no-underline"
              >{{homeCmsData?.data?.attributes?.homeFirstSection?.myLearningButtonText}}</a
            >
            </li>
            <li>
              <a [routerLink]="[browseAllSubjectsLink]"
                class="button primary medium-down-expanded large no-underline">{{
                homeCmsData?.data?.attributes?.homeFirstSection
                ?.subjectButtonText
                }}</a>
            </li>
            <li class="separator" aria-hidden="true"></li>
            <li>
              <a [routerLink]="[helpLink]" class="button primary hollow medium-down-expanded no-underline">{{
                homeCmsData?.data?.attributes?.homeFirstSection
                ?.helpButtonText
                }}</a>
            </li>
          </ul>
        </div>
        <div class="cell medium-6 show-for-medium position-relative">
          <div aria-hidden="true" class="banner-image banner-image--medium banner-image--pixel-depth_1x" [ngStyle]="{
              'background-image':
                'url(' +
                homeCmsData?.data?.attributes?.homeFirstSection?.image1x?.data
                  ?.attributes?.url +
                ')'
            }"></div>
          <div aria-hidden="true" class="banner-image banner-image--medium banner-image--pixel-depth_2x" [ngStyle]="{
              'background-image':
                'url(' +
                homeCmsData?.data?.attributes?.homeFirstSection?.image2x?.data
                  ?.attributes?.url +
                ')'
            }"></div>
        </div>
      </div>
    </div>
  </section>
  <section class="border-bottom-light" aria-describedby="ariaWhyLearnMyWayHeadingLarge">
    <div class="grid-container">
      <div class="grid-x grid-margin-x">
        <div class="cell small-12 medium-5">
          <h2 class="hide-for-medium text-center" id="ariaWhyLearnMyWayHeadingSmall">
            {{ homeCmsData?.data?.attributes?.homeSecondSection?.header }}
          </h2>
          <mono-common-blockquote-image [imageSrc]="
              homeCmsData?.data?.attributes?.homeSecondSection?.image1x?.data
                ?.attributes?.url
            " [image2xSrc]="
              homeCmsData?.data?.attributes?.homeSecondSection?.image2x?.data
                ?.attributes?.url
            " [quote]="
              homeCmsData?.data?.attributes?.homeSecondSection?.imageQuote
            " [language]="language">
          </mono-common-blockquote-image>
        </div>
        <div class="cell medium-7 padding-medium-left-1 padding-tablet-portrait-left-2">
          <h2 class="show-for-medium" id="ariaWhyLearnMyWayHeadingLarge">
            {{ homeCmsData?.data?.attributes?.homeSecondSection?.header }}
          </h2>
          <p>
            {{
            homeCmsData?.data?.attributes?.homeSecondSection?.descriptionTop
            }}
          </p>
          <p>
            {{
            homeCmsData?.data?.attributes?.homeSecondSection
            ?.descriptionBottom
            }}
          </p>
          <a [routerLink]="[homeCmsData?.data?.attributes?.homeSecondSection?.link]"
            class="button primary hollow medium-down-expanded no-underline margin-bottom-1">
            {{
            homeCmsData?.data?.attributes?.homeSecondSection?.readStoryText
            }}</a>
        </div>
      </div>
    </div>
  </section>
  <section aria-describedby="ariaLearningThatFitsHeadingLarge">
    <div class="grid-container">
      <div class="grid-x grid-margin-x">
        <div class="cell small-order-2 medium-order-1 medium-7">
          <h2 class="show-for-medium" id="ariaLearningThatFitsHeadingLarge">
            {{ homeCmsData?.data?.attributes?.homeThirdSection?.header }}
          </h2>
          <div [innerHTML]="homeCmsData?.data?.attributes?.homeThirdSection?.description"></div>
          <a class="button primary hollow medium-down-expanded no-underline margin-bottom-1"
            [routerLink]="[browseAllSubjectsLink]">
            {{
            homeCmsData?.data?.attributes?.homeThirdSection
            ?.tryTopicButtonText
            }}
          </a>
        </div>
        <div class="cell small-12 small-order-1 medium-order-2 medium-5">
          <h2 class="text-center hide-for-medium" id="ariaLearningThatFitsHeadingSmall">
            {{ homeCmsData?.data?.attributes?.homeThirdSection?.header }}
          </h2>
          <div class="banner-image banner-image--tertiary banner-image--pixel-depth_1x" aria-hidden="true" [ngStyle]="{
              'background-image':
                'url(' +
                homeCmsData?.data?.attributes?.homeThirdSection?.image1x?.data
                  ?.attributes?.url +
                ')'
            }"></div>
          <div class="banner-image banner-image--tertiary banner-image--pixel-depth_2x" aria-hidden="true" [ngStyle]="{
              'background-image':
                'url(' +
                homeCmsData?.data?.attributes?.homeThirdSection?.image2x?.data
                  ?.attributes?.url +
                ')'
            }"></div>
        </div>
      </div>
    </div>
  </section>
</main>
<ng-container *ngIf="!userSignedIn">
  <lmw-base-mobile-register-sign-in-bar [language]="language"
    data-test="lmw-base-home-mobile-register-sign-in-bar"></lmw-base-mobile-register-sign-in-bar>
</ng-container>